import { render, staticRenderFns } from "./CasesManage.vue?vue&type=template&id=79d2a6f5&scoped=true&"
import script from "./CasesManage.vue?vue&type=script&lang=js&"
export * from "./CasesManage.vue?vue&type=script&lang=js&"
import style0 from "./CasesManage.vue?vue&type=style&index=0&id=79d2a6f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d2a6f5",
  null
  
)

export default component.exports